// export const API_BASE_URL = "http://localhost/coe/api";
// export const ASSET_URL = "http://localhost/coe/";
export const API_BASE_URL = "http://coe.sudeshmaths.com/api";
export const ASSET_URL = "http://coe.sudeshmaths.com/";
